module.exports = __webpack_public_path__ + "static/media/logo.79839df3.svg";